<template>
  <div class="auth-wrapper auth-cover">
    <div class="auth-inner row m-0">
      <!-- Brand logo-->
      <div class="d-none d-lg-flex col-lg-3 align-items-center justify-content-center">
        <div class="text-center">
          <img
            src="@/assets/images/logo/logo.png"
            alt="Logo"
            class="img-fluid"
            style="max-width: 200px;"
          />
          <h2 class="mt-2 text-primary">Cortinarte</h2>
          <p class="text-muted">Gestión Comercial de Cortinas para Hoteles</p>
        </div>
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <div class="d-none d-lg-flex col-lg-4 align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img
            class="img-fluid auth-cover-illustration"
            src="@/assets/images/pages/auth-v1-top-bg.png"
            alt="auth-cover-illustration"
          />
        </div>
      </div>
      <!-- /Left Text-->

      <!-- Login-->
      <div class="d-flex col-lg-5 align-items-center auth-bg p-4 p-lg-5">
        <div class="col-12 col-sm-12 col-md-10 col-lg-12 px-xl-2 mx-auto">
          <div class="text-center mb-4">
            <h2 class="card-title fw-bold mb-1">¡Bienvenido a Cortinarte! 👋</h2>
            <p class="card-text mb-2">Por favor, inicia sesión en tu cuenta</p>
          </div>

          <form class="auth-login-form mt-2" @submit.prevent="login">
            <div class="mb-1">
              <label for="login-email" class="form-label">Email</label>
              <input
                id="login-email"
                v-model="form.email"
                type="text"
                class="form-control"
                placeholder="john@example.com"
                aria-describedby="login-email"
                tabindex="1"
                autofocus
                required
              />
            </div>
            <div class="mb-1">
              <div class="d-flex justify-content-between">
                <label class="form-label" for="login-password">Contraseña</label>
                <a href="#" @click.prevent="showForgotPassword = true">
                  <small>¿Olvidaste tu contraseña?</small>
                </a>
              </div>
              <div class="input-group input-group-merge form-password-toggle">
                <input
                  id="login-password"
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control form-control-merge"
                  name="login-password"
                  placeholder="············"
                  aria-describedby="login-password"
                  tabindex="2"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showPassword = !showPassword">
                  <i :class="showPassword ? 'feather-eye-off' : 'feather-eye'"></i>
                </span>
              </div>
            </div>
            <div class="mb-1">
              <div class="form-check">
                <input
                  id="remember-me"
                  v-model="form.rememberMe"
                  class="form-check-input"
                  type="checkbox"
                  tabindex="3"
                />
                <label class="form-check-label" for="remember-me"> Recordarme </label>
              </div>
            </div>
            <div class="mb-1" v-if="showCaptcha">
              <label class="form-label">Verificación</label>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-light text-dark">{{ captchaQuestion }}</span>
                <input
                  v-model="captchaUserInput"
                  type="text"
                  class="form-control"
                  placeholder="Resultado"
                  style="max-width: 120px;"
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="generateCaptcha"
                  :disabled="loading"
                >
                  Recargar
                </button>
              </div>
              <small v-if="captchaError" class="text-danger">{{ captchaError }}</small>
            </div>
            <button
              class="btn btn-primary w-100"
              tabindex="4"
              type="submit"
              :disabled="loading"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ loading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
            </button>
          </form>

          <!-- Modal para restablecer contraseña -->
          <div v-if="showForgotPassword" class="modal-overlay" @click="showForgotPassword = false">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <h3 class="modal-title">Restablecer Contraseña</h3>
                <button type="button" class="btn-close" @click="showForgotPassword = false">
                  <i class="feather-x"></i>
                </button>
              </div>
              <div class="modal-body">
                <p class="mb-4">Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.</p>
                <form @submit.prevent="resetPassword">
                  <div class="mb-3">
                    <label for="reset-email" class="form-label">Correo Electrónico</label>
                    <input
                      id="reset-email"
                      v-model="resetForm.email"
                      type="email"
                      class="form-control"
                      placeholder="tu@email.com"
                      required
                    />
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-secondary" @click="showForgotPassword = false">
                      Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="resetLoading">
                      <span v-if="resetLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ resetLoading ? 'Enviando...' : 'Enviar Enlace' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <!-- /Login-->
    </div>

    <!-- Modal de éxito para restablecimiento -->
    <div v-if="showSuccessModal" class="modal-overlay" @click="showSuccessModal = false">
      <div class="modal-content success-modal" @click.stop>
        <div class="modal-header">
          <div class="success-icon">
            <i class="feather-check-circle"></i>
          </div>
          <h3 class="modal-title">¡Enlace Enviado!</h3>
          <button type="button" class="btn-close" @click="showSuccessModal = false">
            <i class="feather-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <p class="success-message">{{ successMessage }}</p>
          <div class="success-actions">
            <button type="button" class="btn btn-primary" @click="showSuccessModal = false">
              Entendido
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService.js'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: '',
        rememberMe: false
      },
      resetForm: {
        email: ''
      },
      loading: false,
      resetLoading: false,
      showPassword: false,
      showForgotPassword: false,
      showRegister: false,
      showSuccessModal: false,
      successMessage: '',
      showCaptcha: false,
      // Captcha
      captchaA: 0,
      captchaB: 0,
      captchaQuestion: '',
      captchaAnswer: 0,
      captchaUserInput: '',
      captchaError: ''
    }
  },
  methods: {
    generateCaptcha() {
      const a = Math.floor(Math.random() * 8) + 2 // 2-9
      const b = Math.floor(Math.random() * 8) + 2 // 2-9
      const ops = ['+', '-']
      const op = ops[Math.floor(Math.random() * ops.length)]
      this.captchaA = a
      this.captchaB = b
      this.captchaQuestion = `¿Cuánto es ${a} ${op} ${b}?`
      this.captchaAnswer = op === '+' ? a + b : a - b
      this.captchaUserInput = ''
      this.captchaError = ''
    },
    validateCaptcha() {
      const user = Number(String(this.captchaUserInput).trim())
      return !Number.isNaN(user) && user === this.captchaAnswer
    },
    async login() {
      console.log('Método login llamado')
      
      if (!this.form.email || !this.form.password) {
        alert('Por favor, completa todos los campos.')
        return
      }
      if (this.showCaptcha && !this.validateCaptcha()) {
        this.captchaError = 'Respuesta incorrecta. Vuelve a intentarlo.'
        this.generateCaptcha()
        return
      }
      
      this.loading = true
      console.log('Intentando login con:', this.form.email)
      
      try {
        const response = await authService.login({
          email: this.form.email,
          password: this.form.password
        })
        
        console.log('Login exitoso:', response)
        this.loading = false
        
        // Redirigir al dashboard usando el router para respetar el base y evitar recarga
        this.$router.replace({ name: 'dashboard' })
      } catch (error) {
        console.error('Error en login:', error)
        this.loading = false
        
        // Mostrar mensaje de error más específico
        let errorMessage = 'Error al iniciar sesión. '
        if (error.response) {
          if (error.response.status === 403) {
            errorMessage += 'Credenciales incorrectas o usuario no encontrado. Verifica tu email y contraseña.'
            // Activar captcha tras fallo de autenticación
            if (!this.showCaptcha) {
              this.showCaptcha = true
              this.generateCaptcha()
            } else {
              // Si ya estaba visible, regenerar para complicar automatización
              this.generateCaptcha()
            }
            this.captchaError = ''
          } else if (error.response.status === 500) {
            errorMessage += 'Error interno del servidor. Verifica que la base de datos esté configurada correctamente.'
          } else {
            errorMessage += `Servidor respondió con código ${error.response.status}`
          }
        } else if (error.request) {
          errorMessage += 'No se pudo conectar con el servidor. Verifica que el backend esté ejecutándose.'
        } else {
          errorMessage += 'Error inesperado.'
        }
        
        alert(errorMessage)
      }
    },
    
    async resetPassword() {
      if (!this.resetForm.email) {
        alert('Por favor, ingresa tu dirección de correo electrónico.')
        return
      }
      
      this.resetLoading = true
      console.log('Intentando restablecer contraseña para:', this.resetForm.email)
      
      try {
        const response = await authService.resetPassword({
          email: this.resetForm.email
        })
        
        console.log('Solicitud de restablecimiento enviada:', response)
        this.resetLoading = false
        
        // Mostrar mensaje de éxito usando la respuesta del servidor
        if (response.success) {
          this.successMessage = response.message
          this.showSuccessModal = true
        } else {
          alert('Error: ' + response.message)
          return
        }
        
        // Cerrar el modal y limpiar el formulario
        this.showForgotPassword = false
        this.resetForm.email = ''
        
      } catch (error) {
        console.error('Error al restablecer contraseña:', error)
        this.resetLoading = false
        
        let errorMessage = 'Error al enviar el enlace de restablecimiento. '
        if (error.response) {
          if (error.response.status === 404) {
            errorMessage += 'No se encontró una cuenta con ese correo electrónico.'
          } else if (error.response.status === 500) {
            errorMessage += 'Error interno del servidor. Inténtalo más tarde.'
          } else {
            errorMessage += `Servidor respondió con código ${error.response.status}`
          }
        } else if (error.request) {
          errorMessage += 'No se pudo conectar con el servidor. Verifica tu conexión a internet.'
        } else {
          errorMessage += 'Error inesperado.'
        }
        
        alert(errorMessage)
      }
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-inner {
  width: 100%;
  max-width: 1200px;
}

.auth-bg {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-login-form {
  background: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.form-control {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.card-title {
  color: #2c3e50;
  font-size: 1.5rem;
}

.card-text {
  color: #6c757d;
  font-size: 0.95rem;
}

/* Desktop adjustments */
@media (min-width: 1200px) {
  .col-lg-12 {
    max-width: 800px;
    margin: 0 auto;
  }
}

/* Responsive adjustments */
@media (max-width: 991.98px) {
  .auth-wrapper {
    padding: 1rem;
  }
  
  .auth-bg {
    min-height: auto;
    padding: 2rem 1rem;
  }
  
  .auth-login-form {
    padding: 1.5rem;
  }
}

/* Modal de éxito */
.success-modal {
  border-left: 4px solid #28a745;
}

.success-icon {
  color: #28a745;
  font-size: 2rem;
  margin-bottom: 1rem;
  text-align: center;
}

.success-message {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  text-align: center;
}

.success-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.success-actions .btn {
  min-width: 120px;
}

@media (max-width: 575.98px) {
  .auth-login-form {
    padding: 1rem;
    margin: 0.5rem;
  }
  
  .card-title {
    font-size: 1.25rem;
  }
  
  .success-icon {
    font-size: 1.5rem;
  }
  
  .success-message {
    font-size: 0.9rem;
  }
}


.auth-inner {
  min-height: 100vh;
}

.auth-bg {
  background: #fff;
  border-radius: 0 0 0 0;
}

@media (min-width: 992px) {
  .auth-bg {
    border-radius: 0 0 0 0;
  }
}

.card-title {
  color: #5a5a5a;
}

.form-label {
  color: #5a5a5a;
  font-weight: 500;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 6px;
  font-weight: 500;
  padding: 12px 24px;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.form-control {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 12px 16px;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.input-group-text {
  background: transparent;
  border: 1px solid #d1d5db;
  border-left: none;
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Modal para restablecer contraseña */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: white;
  border-radius: 15px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e9ecef;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.btn-close:hover {
  background: #f8f9fa;
  color: #495057;
}

.modal-body {
  padding: 2rem;
}

.modal-body p {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
}

.gap-2 {
  gap: 0.5rem;
}

.btn-secondary {
  background: #6c757d;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

/* Responsive para el modal */
@media (max-width: 576px) {
  .modal-content {
    width: 95%;
    margin: 1rem;
  }
  
  .modal-header,
  .modal-body {
    padding: 1rem;
  }
  
  .modal-title {
    font-size: 1.25rem;
  }
}
</style>